'use client';
import { makeStyles } from '@fluentui/react-components';
export const useVideoStyles = makeStyles({
    root: {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '100%',
        height: 'auto'
    }
});
